
















































































































































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { ApiService } from '@/api/api.service'
import Alert from '@/components/Alert.vue'
import { getBoUrl } from '@/api/http-constants'
import SmoothReflow from '@/components/_transitions/SmoothReflow.vue'
import PhoneNumberInput from '@/components/Profil/PhoneNumberInput.vue'

interface IUser {
    avatar: string
    email: string
    currentPassword: string
    plainPassword: string
    phone: string
}

interface ISettingsState {
    acceptNewsletter: boolean
    newsletterType: string
}

interface ISettingsRequest {
    acceptNewsletter: number
    newsletterType: number
}

@Component({
    components: {
        Alert,
        SmoothReflow,
        PhoneNumberInput,
    },
})
export default class Compte extends Vue {
    apiService = new ApiService()
    avatars = null
    showPassword = false
    showProfilePassword = false

    id: number = null
    user: IUser = {
        avatar: null,
        email: null,
        currentPassword: null,
        plainPassword: null,
        phone: null,
    }
    profile = {
        nickname: '',
        selectedAvatar: null as string | null,
        password: '',
    }
    settings: ISettingsState = {
        acceptNewsletter: false,
        newsletterType: null,
    }

    pass = {
        old: '',
        new: '',
    }

    errors = {
        mail: '',
        old: '',
        new: '',
        phone: '',
        profilePassword: '',
    }

    userImage
    fileName: string = null

    get avatarList(): string[] {
        if (!this.avatars) return []
        return this.avatars.avatars || this.avatars.files || []
    }

    get avatarsBasePath(): string {
        return this.avatars ? getBoUrl().replace(/\/$/, '') + this.avatars.path : ''
    }

    mounted() {
        requestAnimationFrame(() => {
            ;(<any>$('.popover-dismiss')).popover({
                trigger: 'hover',
                container: 'body',
                boundary: 'window',
            })
        })
    }

    async created() {
        if (UserModule.token == undefined) {
            UserModule.Init()
        }
        this.id = UserModule.userInfos.id

        const resp2 = await this.apiService.getAvatars()
        this.avatars = resp2.data
        console.log({ ...this.avatars })

        const resp = await this.apiService.getBuyer(this.id)
        const userInfos = resp.data
        console.log(userInfos)

        this.user = this.parseUser(userInfos, this.avatars)
        this.settings = this.parseSettings(userInfos)
        this.profile.nickname = userInfos.nickname || ''
        if (userInfos.imagePath && this.avatars && this.avatars.path) {
            this.profile.selectedAvatar = this.parseAvatar(userInfos.imagePath, this.avatars.path)
        }
    }

    async handleSubmit(e) {
        e.preventDefault()
        this.errors.old = ''
        this.errors.new = ''
        this.errors.mail = ''
        this.errors.phone = ''

        if (this.user.phone.length !== 10) {
            this.errors.phone =
                'Votre numéro de téléphone doit contenir exactement 10 chiffres'
            return
        }

        if (this.pass.new !== '' && this.pass.old === '') {
            this.errors.old += 'Veuillez renseigner votre ancien mot de passe'
            return
        }
        if (
            this.pass.old !== '' &&
            this.pass.new !== '' &&
            !this.validPass(this.pass.new)
        ) {
            this.errors.new +=
                'Votre mot de passe doit contenir au minimum 8 caractères, un chiffre et une lettre, sans caractères spéciaux'
            return
        }

        if (this.pass.old !== '' && this.pass.new !== '') {
            this.user.currentPassword = this.pass.old
            this.user.plainPassword = this.pass.new
        }

        let errors = 0

        /**
         * Enregistrement des paramètres du compte
         */
        try {
            this.user.avatar = this.avatars.path + this.parseAvatar(
                UserModule.userInfos.imagePath,
                this.avatars.path
            )
            const resp = await this.apiService.patchBuyer(this.id, this.user)
            this.user.currentPassword = ''
            this.user.plainPassword = ''
            this.pass = {
                old: '',
                new: '',
            }
        } catch (e) {
            if (e.data.message === 'Mot de passe incorrect') {
                this.errors.old += e.data.message
            }
            errors++
        }

        /**
         * Enregisitrement des préférences de notification
         */
        try {
            const settingsReq = this.formatSettigns(this.settings)
            const resp = await this.apiService.patchPreferences(
                this.id,
                settingsReq
            )
        } catch (e) {
            errors++
        }

        if (errors === 0) {
            ;(<Alert>this.$refs.alert).handleAlert(
                'success',
                'Enregistrement effectué'
            )
        } else {
            ;(<Alert>this.$refs.alert).handleAlert(
                'danger',
                "Erreur lors de l'enregistrement"
            )
        }
    }

    async handleProfileSubmit(e) {
        e.preventDefault()
        this.errors.profilePassword = ''

        if (!this.profile.password) {
            this.errors.profilePassword = 'Veuillez saisir votre mot de passe actuel'
            return
        }

        try {
            await this.apiService.patchBuyer(this.id, {
                nickname: this.profile.nickname,
                avatar: this.profile.selectedAvatar ? this.avatars.path + this.profile.selectedAvatar : null,
                currentPassword: this.profile.password,
            })
            UserModule.SetNickname(this.profile.nickname)
            UserModule.SetAvatar(this.profile.selectedAvatar ? this.avatars.path + this.profile.selectedAvatar : null)
            this.profile.password = ''
            ;(<Alert>this.$refs.alert).handleAlert('success', 'Profil mis à jour')
        } catch (e) {
            const message = (e && e.data && e.data.message) ? e.data.message : 'Mot de passe incorrect'
            this.errors.profilePassword = message
        }
    }

    async handleRgpdDelete() {
        ;(<any>$('#rgpdModal')).modal('hide')
        try {
            await this.apiService.postRgpd(this.id, {})
            ;(<Alert>this.$refs.alert).handleAlert(
                'success',
                'La demande de suppression de votre compte a été envoyée à nos administrateurs.'
            )
        } catch (e) {
            ;(<Alert>this.$refs.alert).handleAlert(
                'info',
                'La demande de suppression de votre compte a déjà été envoyée'
            )
        }
    }

    validEmail(email: string): boolean {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email)
    }

    validPass(pass: string): boolean {
        const re = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
        return re.test(pass)
    }

    formatSettigns(settings: ISettingsState): ISettingsRequest {
        return {
            acceptNewsletter: settings.acceptNewsletter ? 1 : 0,
            newsletterType: parseInt(settings.newsletterType, 10),
        }
    }

    parseSettings(userInfos): ISettingsState {
        return {
            acceptNewsletter: userInfos.acceptNewsletter,
            newsletterType: userInfos.newsletterType || '1',
        }
    }

    parseUser(userInfos, avatars): IUser {
        return {
            // civility: userInfos.civility,
            // lastname: userInfos.lastname,
            // firstname: userInfos.firstname,
            // nickname: userInfos.nickname,
            email: userInfos.email,
            currentPassword: '',
            plainPassword: '',
            avatar: this.parseAvatar(userInfos.imagePath, this.avatars.path),
            phone: userInfos.phone,
        }
    }

    parseAvatar(imagePath, avatarsPath) {
        return imagePath.replace(avatarsPath, '')
    }

    get boUrl() {
        return getBoUrl()
    }
}
